import ApiService from 'services/ApiService/ApiService';

import coreService from './core';


const CHUNK_SIZE = 8_000_000;

async function finishUpload({ videoId, uploadId, status }) {
  const { id } = await coreService.getUser();
  const url = coreService.computeURL(`mediaItemsForModels/${id}/uploadVideos/uploadCompletedNotifications`);

  const { token } = await coreService.getToken();
  const headers = { 'Authorization': `Bearer ${token}` };
  const payload = { videoId, uploadId, status };

  const { data } = await ApiService.post(url.toString(), { headers, data: payload });

  return data;
}

export default async function uploadVideo(options) {
  const { url, headers, file, onProgress, title, price, scheduledAt } = options;
  const fileSize = file.size;
  const chunksNum = Math.ceil(fileSize / CHUNK_SIZE);
  const payload = { numberOfParts: chunksNum };
  if (title) {
    payload.title = title;
  }
  if (price) {
    payload.price = price;
  }
  if (scheduledAt) {
    payload.scheduledAt = scheduledAt;
  }

  const { data } = await ApiService.post(url, { headers, data: payload });

  const { videoId, uploadId, temporaryUrlList } = data;

  const progress = new Array(chunksNum);
  progress.fill(0);

  const promises = temporaryUrlList.map((chunkURL, index) => {
    const start = index * CHUNK_SIZE;
    const end = start + CHUNK_SIZE;
    const blob = index < chunksNum - 1 ? file.slice(start, end) : file.slice(start);

    return ApiService.put(chunkURL, {
      headers: { 'content-type': 'application/octet-stream' },
      withCredentials: false,
      data: blob,
      onUploadProgress: ({ loaded }) => {
        progress[index] = loaded;

        const progressSize = progress.reduce((r, c) => r + c, 0);
        const pctLoaded = Math.round(progressSize * 100 / fileSize);

        onProgress?.(pctLoaded);
      },
    });
  });

  let uploadStatus = undefined;

  try {
    await Promise.all(promises);
    uploadStatus = 'UPLOADED';
  } catch (err) {
    uploadStatus = 'UPLOAD_FAILED';
  }

  await finishUpload({ videoId, uploadId, status: uploadStatus });

  onProgress?.(100);
}
